import { map, catchError } from 'rxjs/operators';
import { Injectable, ApplicationRef, ComponentFactoryResolver, NgZone } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpClientService } from '../http-client-service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from 'src/app/config/config.service';
import { Observable, throwError } from 'rxjs';
import { ToasterEnum } from '../models/ToasterModel';

@Injectable()
export class NotificationService {
    httpClient: HttpClientService;
    baseUrl: any;
    constructor(private toastr: ToastrService, config: ConfigService, private appl: ApplicationRef, httpClient: HttpClientService, private http: HttpClient, private componentFactoryResolver: ComponentFactoryResolver) {
        this.httpClient = httpClient;
        this.baseUrl = config.get('extApiUrl');
        if (!this.baseUrl) {
            config.load().then(() => {
                this.baseUrl = config.config['extApiUrl'];
            });
        }
    }

    showWarning(message: string, title: string) {
        let options = {
            positionClass: 'toast-center-center',
            closeButton: true,
            tapToDismiss: false,
            enableHtml: true,
            maxOpened: 1,
            newestOnTop: true,
            autoDismiss: true,
            disableTimeOut: true,
            preventDuplicates: true,
            preventOpenDuplicates: true
        }
        this.toastr.warning(message, title, options);
        setTimeout(() => {
            this.clearToasts(ToasterEnum.maxOpened);
        }, 500);
    }

    showWarningWithHtml(message: string, title: string) {
        let options = {
            positionClass: 'toast-center-center',
            closeButton: true,
            dismiss: 'click',
            extendedTimeOut: 1000
        }
        this.toastr.warning(message, title, options);
    }

    showError(message: string, title: string) {
        let options = {
            positionClass: 'toast-top-right',
            closeButton: true,
            tapToDismiss: false,
            enableHtml: true,
            maxOpened: 1,
            newestOnTop: true,
            autoDismiss: true,
            disableTimeOut: true,
            preventDuplicates: true,
            preventOpenDuplicates: true
        }
        this.toastr.error(message, title, options);
        setTimeout(() => {
            this.clearToasts(ToasterEnum.maxOpened);
        }, 500);
    }

    showErrorWithButton(message: string, title: string) {
        let options = {
            positionClass: 'toast-top-right',
            closeButton: true,
            tapToDismiss: false,
            enableHtml: true,
            maxOpened: 1,
            newestOnTop: true,
            autoDismiss: true,
            disableTimeOut: true,
            preventDuplicates: true,
            preventOpenDuplicates: true
        }
        console.log(this.toastr.toasts);
        this.toastr.error(message + '<p><a type="button" class="btn clear btn-toastr" onclick="toastr.clear()">OK</a></p>', title, options);
    }

    showSuccess(message: string, title: string) {
        let options = {
            positionClass: 'toast-top-right',
            closeButton: true,
            dismiss: 'click',
            extendedTimeOut: 1000
        }
        this.toastr.success(message, title, options);
    }

    showInfo(message: string, title: string) {
        let options = {
            positionClass: 'toast-top-right',
            closeButton: true,
            progressAnimate: 'decreasing',
            dismiss: 'click',
            extendedTimeOut: 1000
        }
        this.toastr.info(message, title, options);
    }

    public getTermsAndConditionsData() {
        return this.httpClient.get('api/Login/GetLatestTermsAndConditions').pipe(map(res => {
            return this.extractData(res);
        })).pipe(catchError(this.handleError));
    }

    private handleError(error: any): any {
        let errorMsg = (error.message) ? error.message : error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        // Observable.throw(errorMsg);
        return throwError(() => error);
    }

    private extractData(res: Response) {
        let body = res;
        return body || {};
    }

    clearAllToasts() {
        if (this.toastr.error.length > 0) {
            this.toastr.clear();
        }
    }

    clearToasts(maxLength: number) {
        var totalTosts = this.toastr.toasts;
        if (totalTosts.length > maxLength) {
            let toastToBeRemoved: number = (totalTosts.length - maxLength);
            totalTosts.forEach((toast, index) => {
                if (index < toastToBeRemoved) {
                    this.toastr.clear(toast.toastId);
                }
            });
        }
    }
}